import type { DataGridColumnDefOverride } from 'types/DataGridTypes';

export type GridPinnedColumnsModel = {
  left?: string[];
  right?: string[];
};

export function derivePinnedColumnsFromOverrides(
  overrides?: Record<string, DataGridColumnDefOverride>,
): GridPinnedColumnsModel | undefined {
  if (!overrides) return undefined;

  const left: string[] = [];
  const right: string[] = [];

  Object.entries(overrides).forEach(([field, config]) => {
    if (config?.pinned === 'left') left.push(field);
    if (config?.pinned === 'right') right.push(field);
  });

  if (!left.length && !right.length) return undefined;
  return { left, right };
}

export function normalizePinnedColumns(
  model?: GridPinnedColumnsModel,
): GridPinnedColumnsModel | undefined {
  if (!model) return undefined;
  const left = model.left ?? [];
  const right = model.right ?? [];
  if (!left.length && !right.length) return undefined;
  return { left, right };
}
